import { Platformer } from "./platformer/index";
import { White } from "./white/index";
import { Wood } from "./wood/index";

const DMGarrays = [Platformer, White, Wood];

const DMGnames = ["Platformer", "White", "Wood Grain"];

export { DMGarrays, DMGnames };
